import { render } from "./Authentication.vue?vue&type=template&id=648750cc&ts=true"
import script from "./Authentication.ts?vue&type=script&lang=ts&external"
export * from "./Authentication.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__